import {DOMAIN_API} from "./local_settings";
import {
    DOMAIN_DEMO_NAME, DOMAIN_DEMO_API
} from "./demo_settings";
import {AuthConfig} from '../modules/auth/_services/auth-config';
import {environment} from "../../environments/environment";
import {UserContact} from "../models/user-contact";
import {UserBalance} from "../models/user-balance";
import {GamesProvider} from "../models/gamesProvider";
import {AppVersion} from '../models/appVersion';
import {SupportModel} from "../models/support/support.model";

let domainApiUrl = DOMAIN_API;
if(window.location.hostname == DOMAIN_DEMO_NAME){
    domainApiUrl = DOMAIN_DEMO_API;
}

let API = domainApiUrl;
let API_SENETPRO = API + '/senetpro';
const USERS = API_SENETPRO + '/users';

const GAMES = API_SENETPRO + '/games';
const REDEEM = API_SENETPRO + '/redeem';

if (environment.frontEndTest) {
    API_SENETPRO = DOMAIN_API + '/client';
}

export const AUTH_CONFIG: AuthConfig = {
  checkPhoneAndSendPin: USERS + '/user/login',
  login: USERS + '/user/auth',
  logout: USERS + '/session/logout',
  forgotPassword: API_SENETPRO +'/apps/location/forgot',
  loginSendResetCode: API_SENETPRO +'/apps/location/verify',
  loginAfterReset: API_SENETPRO +'/apps/location/password',
  register: API_SENETPRO +'/apps/location/register',
  addByPhone: USERS + '/password/addByPhone',
  refresh: USERS + '/session/refresh',
};
if (environment.frontEndTest) {
    AUTH_CONFIG.checkPhoneAndSendPin = API_SENETPRO + '/jsons/find/file?name=loginAddPasswordError';
    AUTH_CONFIG.login = API_SENETPRO + '/users/session/login';
    AUTH_CONFIG.refresh = API_SENETPRO + '/users/session/refresh';
    AUTH_CONFIG.logout = API_SENETPRO + '/users/session/logout';
    AUTH_CONFIG.register =  API_SENETPRO +'/apps/location/register';
    AUTH_CONFIG.addByPhone =  API_SENETPRO + '/users/session/login';

    AUTH_CONFIG.forgotPassword =  API_SENETPRO + '/jsons/find/file?name=success';
    AUTH_CONFIG.loginSendResetCode =  API_SENETPRO + '/jsons/find/file?name=success';
    AUTH_CONFIG.loginAfterReset = API_SENETPRO + '/users/session/login';
}

export const USER_CONTACT_CONFIG: UserContact = {
    save: USERS + '/contact/save',
    onChangePassword: USERS + '/change/password',
    onChangePin: USERS + '/change/pin',
};
if (environment.frontEndTest) {
    USER_CONTACT_CONFIG.save =  API_SENETPRO + '/jsons/find/file?name=success';
    USER_CONTACT_CONFIG.onChangePassword =  API_SENETPRO + '/jsons/find/file?name=success';
    USER_CONTACT_CONFIG.onChangePin =  API_SENETPRO + '/jsons/find/file?name=success';
}

export const USER_BALANCE_CONFIG: UserBalance = {
    getBalance: USERS + '/balance',
    getGameBalance: REDEEM + '/page/game',
    increaseBalance: API_SENETPRO + '/games/game/deposit', // need To change (shop page game play popup)
    redeem: REDEEM + '/game',
    withdraw: API_SENETPRO +'/apps/locationUser/depositFromSpendAccount',
}
if (environment.frontEndTest) {
    USER_BALANCE_CONFIG.getBalance = API_SENETPRO + '/jsons/find/file?name=senetGetMainBalance';
    USER_BALANCE_CONFIG.increaseBalance = API_SENETPRO + '/jsons/find/file?name=success';
    USER_BALANCE_CONFIG.getGameBalance = API_SENETPRO + '/jsons/find/file?name=getGameBalance';
    USER_BALANCE_CONFIG.redeem = API_SENETPRO + '/jsons/find/file?name=successTest';
    USER_BALANCE_CONFIG.withdraw = API_SENETPRO + '/jsons/find/file?name=success';
}

export const GAMES_PROVIDER_CONFIG: GamesProvider = {
    getSenetSession: API + '/games/senet/session/create',
}
if (environment.frontEndTest) {
    GAMES_PROVIDER_CONFIG.getSenetSession = API_SENETPRO + '/jsons/find/file?name=getSenetSession';
}

export const SUPPORT_CONFIG: SupportModel = {
    session: API_SENETPRO + '/chat/session/create', // need To change
};
if (environment.frontEndTest) {
    SUPPORT_CONFIG.session = API_SENETPRO + '/jsons/find/file?name=createSupportSession';
}

export const TERMS_AND_CONDITIONS_CONFIG = {
    getPageInfo: API_SENETPRO +'/app/terms',
};
if (environment.frontEndTest) {
    TERMS_AND_CONDITIONS_CONFIG.getPageInfo = API_SENETPRO + '/jsons/find/file?name=termsAndConditions'
}

export const APP_VERSION_CONFIG: AppVersion = {
    version: API_SENETPRO +'/apps/location/version',
};

export const STATES_CONFIG = {
    getStates:  API_SENETPRO + '/states/states',
};
if (environment.frontEndTest) {
    STATES_CONFIG.getStates = API_SENETPRO + '/jsons/find/file?name=statesList'
}

export const GAMES_CONFIG = {
    getPageInfo: GAMES + '/games'
};
if (environment.frontEndTest) {
    GAMES_CONFIG.getPageInfo = API_SENETPRO + '/jsons/find/file?name=senetGamesPageInfo';
}
